import React from 'react';

const NewDeviceWizard = ({ onDeviceAdded, onCancel }) => {
  const handleFinish = () => {
    if (typeof onDeviceAdded === 'function') {
      onDeviceAdded(); // Rafraîchit la liste des devices après retour depuis l'AP
    }
  };

  return (
    <div
      className="add-new-boxed"
      style={{
        maxWidth: 900,
        margin: '10px auto',
        padding: 20,
        backgroundColor: '#fefefe',
        border: '1px solid #ccc',
        borderRadius: 12,
      }}
    >
      <h2 style={{ marginBottom: 10 }}>🛠 Ajouter un nouvel appareil</h2>

      <ol style={{ lineHeight: 1.8, paddingLeft: 20 }}>
        <li>Branchez votre nouvel appareil à une prise courant dans un endroit où vous captez votre Wi-Fi.</li>
        <li>Dans les réglages Wi-Fi de votre téléphone ou ordinateur, connectez-vous au nouveau réseau Wi-Fi nommé <strong>“LumieresDeJardin”</strong>.</li>
        <li>Une page internet de configuration va s’ouvrir automatiquement (Safari, Edge, etc). Sinon, ouvrez <code>http://192.168.4.1</code> manuellement dans votre navigateur.</li>
        <li>Choisissez votre réseau Wi-Fi dans la liste, entrez votre mot de passe et confirmez.</li>
        <li>Une fois configuré, votre nouvel appareil sera connecté à votre réseau Wi-Fi. </li>
        <li>Dans les réglages Wi-Fi de votre téléphone ou ordinateur, reconnectez-vous à votre réseau Wi-Fi.</li>
        <li>Vous pouvez alors revenir sur l'app ou la page web lumieresdejardin.fr.</li>
        <li>Cliquez sur le bouton vert "J'ai terminé la configuration".</li>
        <li>Votre nouvel appareil apparaîtra automatiquement dans la liste de vos appareils.</li>
      </ol>

      <div style={{ marginTop: 30, display: 'flex', gap: 12 }}>
        <button
          onClick={handleFinish}
          style={{
            padding: '10px 20px',
            backgroundColor: '#28a745',
            color: '#fff',
            fontWeight: 'bold',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
          }}
        >
          ✅ J’ai terminé la configuration
        </button>

        <button
          onClick={onCancel}
          style={{
            padding: '10px 20px',
            backgroundColor: '#ccc',
            color: '#000',
            fontWeight: 'bold',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
          }}
        >
          ❌ Annuler
        </button>
      </div>
    </div>
  );
};

export default NewDeviceWizard;